import styled from 'styled-components';

import { black, white } from '../../modules/colors';
import media from '../../modules/media';

export const Wrapper = styled.div`
  width: 20px;
  height: 20px;
  flex-direction: column;
  justify-content: space-around;
  display: none;

  ${media.desktop} {
    display: flex;
    z-index: 10;
  }
`;

const Line = styled.div`
  width: 100%;
  height: 2px;
  background-color: ${black};
  border-radius: 4px;
  transition: all 0.3s linear;
  position: relative;
  transform-origin: 0.2px;

  &:focus {
    outline: none;
  }

  ${media.desktop} {
    ${(props) => props.isOpen && `background-color: ${white};`}
  }
`;

export const Line1 = styled(Line)`
  transition: transform 0.5s;
  transform: rotate(${(props) => (props.isOpen ? 45 : 0)}deg);
`;

export const Line2 = styled(Line)`
  transition: opacity 0.5s;
  ${(props) => props.isOpen && 'opacity: 0;'}
`;

export const Line3 = styled(Line)`
  transition: transform 0.5s;
  transform: rotate(${(props) => (props.isOpen ? -45 : 0)}deg);
`;
